import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'

import {
	BreadCrumb,
	Button,
	CardList,
	ModalBase,
	SelectRadio,
	Title,
} from '@components/atoms'
import { Option } from '@components/atoms/SelectBase/SelectMove'
import { Add16Filled } from '@fluentui/react-icons'
import { simulatedAPI } from '@services/SimulatedAPI'

import { SimulateStyles } from '../style'

const { container, title, buttonSelectSimulate } = SimulateStyles

export type SelectWeek = {
	selectWeek?: { value: string | number; name: string }
}

export const SimulateShow = () => {
	const [name, setName] = useState<string>('')
	const [values, setValues] = useState<SelectWeek>()
	const [options, setOptions] = useState<Array<Option>>()
	const [openModal, setOpenModal] = useState(false)
	const [isDisabled, setIsDisabled] = useState(true)

	const [getWeeksSimulate, { data, isSuccess }] =
		simulatedAPI.useGetWeeksSimulateMutation()

	const [getAllSimulate, { data: dataAll, isSuccess: isSuccessAll }] =
		simulatedAPI.useGetAllSimulatedMutation()

	const { id } = useParams()

	const handleSelect = () => {
		setOpenModal(false)
	}

	useEffect(() => {
		if (id) {
			getAllSimulate({ page: 1, limit: 1000 })
			getWeeksSimulate({ page: 1, limit: 1000, categoryId: id })
		}
	}, [getAllSimulate, getWeeksSimulate, id])

	useEffect(() => {
		if (isSuccess && data) {
			setOptions(
				data.data.map((item) => {
					return {
						value: item.id,
						option: item.name,
					}
				})
			)
		}
	}, [isSuccess, data])

	useEffect(() => {
		if (isSuccessAll && dataAll) {
			const string = dataAll.items.find(
				(item) => Number(item.id) === Number(id)
			)

			if (string) {
				setName(string.name)
			}
		}
	}, [dataAll, id, isSuccessAll])

	useEffect(() => {
		if (values?.selectWeek?.value) {
			setIsDisabled(false)
		} else {
			setIsDisabled(true)
		}
	}, [values?.selectWeek?.value])

	return (
		<div className={container()}>
			<div>
				<BreadCrumb
					buttonReturn
					locations={
						name
							? [
									{ name: 'Simulados', link: '/simulados' },
									{ name, link: '/simulados' },
							  ]
							: []
					}
				/>

				<div className={title()}>
					<Title variant='h1' color='$neutral160'>
						{name}
					</Title>
				</div>
			</div>

			<div>
				<button
					type='button'
					className={buttonSelectSimulate()}
					onClick={() => {
						setOpenModal(true)
					}}
				>
					{values?.selectWeek?.value ? (
						<h6>{values?.selectWeek.name}</h6>
					) : (
						<h6>Escolha o simulado</h6>
					)}
					<Add16Filled />
				</button>
			</div>

			<div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
				{isDisabled ? (
					<>
						<CardList name='Formato treino' disabled={isDisabled} />
						<CardList name='Formato de Prova' disabled={isDisabled} />
					</>
				) : (
					<>
						<Link to={`/simulados/treino/${values?.selectWeek?.value}`}>
							<CardList name='Formato treino' />
						</Link>
						<Link to={`/simulados/prova/${values?.selectWeek?.value}`}>
							<CardList name='Formato de Prova' />
						</Link>
					</>
				)}
			</div>

			<ModalBase
				title='Escolha o simulado'
				open={openModal}
				onOpenChange={() => {
					setOpenModal(false)
					setValues({ selectWeek: undefined })
				}}
			>
				<div
					style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
				>
					<div
						style={{
							marginTop: '34px',
							display: 'flex',
							flexDirection: 'column',
						}}
					>
						<SelectRadio
							options={options || []}
							onChange={(e) => {
								setValues({ selectWeek: { value: e.value, name: e.option } })
							}}
							value={values?.selectWeek?.value}
						/>

						<div
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								gap: '26px',
								marginTop: '17px',
								paddingLeft: '16px',
							}}
						>
							<Button
								css={{ maxWidth: '164px' }}
								disabled={!values?.selectWeek}
								onClick={handleSelect}
							>
								Confirmar
							</Button>
							<Button
								outlined
								css={{ maxWidth: '164px' }}
								color='secondary'
								onClick={() => {
									setOpenModal(false)
									setValues({ selectWeek: undefined })
								}}
							>
								Cancelar
							</Button>
						</div>
					</div>
				</div>
			</ModalBase>
		</div>
	)
}
